// L'EFFACEUR — Loading skeleton (DA cyber)
// Variantes : SkeletonText, SkeletonCard, SkeletonTable

import { useEffect } from 'react';

const shimmerStyle = {
  background: 'linear-gradient(90deg, rgba(31,41,55,0.6) 0%, rgba(0,245,255,0.1) 50%, rgba(31,41,55,0.6) 100%)',
  backgroundSize: '200% 100%',
  animation: 'leffaceur-shimmer 1.6s infinite',
};

const styleSheet = `
@keyframes leffaceur-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
`;

const ensureStyles = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById('leffaceur-skeleton-shimmer')) return;
  const style = document.createElement('style');
  style.id = 'leffaceur-skeleton-shimmer';
  style.innerHTML = styleSheet;
  document.head.appendChild(style);
};

export const LoadingSkeleton = ({ className = '', width, height, style: extraStyle = {} }) => {
  useEffect(() => { ensureStyles(); }, []);
  return (
    <div
      className={`rounded ${className}`}
      style={{ ...shimmerStyle, width: width || '100%', height: height || '20px', ...extraStyle }}
      aria-busy="true"
      aria-live="polite"
    />
  );
};

export const SkeletonText = ({ lines = 3 }) => (
  <div className="space-y-2">
    {Array.from({ length: lines }).map((_, i) => (
      <LoadingSkeleton key={i} height="14px" width={i === lines - 1 ? '60%' : '100%'} />
    ))}
  </div>
);

export const SkeletonCard = () => (
  <div className="glass-card border border-gray-800 p-6 space-y-4">
    <LoadingSkeleton height="24px" width="40%" />
    <SkeletonText lines={3} />
    <div className="flex gap-2 mt-4">
      <LoadingSkeleton width="100px" height="36px" />
      <LoadingSkeleton width="100px" height="36px" />
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="space-y-2">
    <div className="flex gap-4 pb-2 border-b border-gray-800">
      {Array.from({ length: cols }).map((_, i) => (
        <LoadingSkeleton key={i} height="14px" width="20%" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex gap-4 py-3 border-b border-gray-800/50">
        {Array.from({ length: cols }).map((_, j) => (
          <LoadingSkeleton key={j} height="14px" width="20%" />
        ))}
      </div>
    ))}
  </div>
);

export default LoadingSkeleton;
